"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEND_CREDIT_CARD_EMAIL = exports.REMOVE_PAYMENT_METHOD = exports.UPDATE_PAYMENT_INFORMATION_BY_LEGALENTITY = exports.UPDATE_PAYMENT_INFORMATION = void 0;
exports.UPDATE_PAYMENT_INFORMATION = `
	mutation updateZuoraAccountPaymentInformation($paymentInfo: ZuoraAccountPaymentInfo){
		updateZuoraAccountPaymentInformation(paymentInfo: $paymentInfo) {
			Success Errors {
				Message Code
			}
		}
	}
`;
exports.UPDATE_PAYMENT_INFORMATION_BY_LEGALENTITY = `
	mutation updateZuoraAccountPaymentInformationByLegalEntity($zuoraId: String,$paymentInfo: ZuoraAccountPaymentInfoV2, $legalEntity: String, $cardType: String, $currency: String ) {
		updateZuoraAccountPaymentInformationByLegalEntity(zuoraId: $zuoraId,paymentInfo: $paymentInfo, legalEntity: $legalEntity, cardType: $cardType, currency: $currency) {
				success
				errors {
						message
						code
				}
		}
	}
`;
exports.REMOVE_PAYMENT_METHOD = `
	mutation deletePaymentMethod($paymentMethodId: String!, $isDefault: Boolean, $cardNumberLastFour: String, $hasActiveSubscriptions: Boolean, $hasActiveStandingOrders: Boolean, $hasUserPhysicalAwaitingOrders:Boolean, $legalEntity: String, $fromSetDefaultPaymentAction:Boolean){
		deletePaymentMethod(paymentMethodId: $paymentMethodId, isDefault: $isDefault, cardNumberLastFour: $cardNumberLastFour, hasActiveSubscriptions: $hasActiveSubscriptions, hasActiveStandingOrders: $hasActiveStandingOrders, hasUserPhysicalAwaitingOrders: $hasUserPhysicalAwaitingOrders, legalEntity: $legalEntity, fromSetDefaultPaymentAction: $fromSetDefaultPaymentAction) {
			success reasons {
				message
				code
			}
		}
	}
`;
exports.SEND_CREDIT_CARD_EMAIL = `
	mutation sendCreditCardMail($definitionKey: String!, $cardNumberLastFour: String!){
		sendCreditCardMail(definitionKey: $definitionKey, cardNumberLastFour: $cardNumberLastFour) { success }
	}
`;
//# sourceMappingURL=credit-card-queries.js.map